export default __webpack_public_path__ + "static/media/demo_2.63be7c54.png";